import { $ } from './../../helpers/query'
import {SectionAnimationTemplate} from './SectionAnimationTemplate'

export class BuildingIntroAnimation extends SectionAnimationTemplate {
  constructor() {
    super();
    this.buildIntroSection = document.querySelector('#building-intro-section');
    this.buildIntroOuterCont = this.buildIntroSection.querySelector('.building-intro__outer-container');
    this.buildIntroBgImg = this.buildIntroSection.querySelector('.building-intro__bg img');
    this.buildIntroCont = this.buildIntroSection.querySelector('.building-intro__container');
    this.buildIntroTitle = this.buildIntroSection.querySelector('.building-intro__title');
    this.buildIntroBtn = this.buildIntroSection.querySelector('.building-intro__view-btn');
    this.buildIntroBeforeClone = this.cloneNextSibling(this.buildIntroSection.previousElementSibling);
  }

  // 1. Interract whith Previous section
  // -- 1.1. Interract forward
  onVisitDown() {
    this.hideVideo()
    this.buildIntroBeforeClone.classList.remove('invisible')
    this.buildIntroBgImg.classList.add('bg-img--zoomed')
    this.buildIntroTitle.classList.remove('building-intro__title--start')
    if (this.buildIntroBtn) { this.buildIntroBtn.classList.remove('building-intro__view-btn--start') }
    this.buildIntroBeforeClone.querySelector('.building-intro__bg img').classList.add('bg-img--zoomed')
    this.buildIntroBeforeClone.querySelector('.building-intro__title').classList.remove('building-intro__title--start')
    if (this.buildIntroBtn) { this.buildIntroBeforeClone.querySelector('.building-intro__view-btn').classList.remove('building-intro__view-btn--start') }
    setTimeout(() => {
      this.buildIntroBeforeClone.classList.add('invisible')
      this.buildIntroBeforeClone.querySelector('.building-intro__title').classList.add('building-intro__title--start')
      if (this.buildIntroBtn) { this.buildIntroBeforeClone.querySelector('.building-intro__view-btn').classList.add('building-intro__view-btn--start') }
    }, this.ANIM_DUR + this.EXTRA_DUR)
    setTimeout(() => {
      window.dispatchEvent(this.transitionEnd)
    }, this.TRANS_DUR)
  }

  // -- 1.2. Interract back
  onLeaveUp() {
    window.dispatchEvent(this.transitionStart)
    this.buildIntroBgImg.classList.add('bg-img--zoomed-max')
    this.buildIntroCont.classList.add('building-intro__container--fade-end')
    setTimeout(() => {
      this.buildIntroBgImg.classList.remove('bg-img--zoomed')
      this.buildIntroBgImg.classList.remove('bg-img--zoomed-max')
      this.buildIntroCont.classList.remove('building-intro__container--fade-end')
      this.buildIntroTitle.classList.add('building-intro__title--start')
      if (this.buildIntroBtn) { this.buildIntroBtn.classList.add('building-intro__view-btn--start') }
    }, this.ANIM_DUR + this.EXTRA_DUR)
  }

  // 2. Interract whith Next section
  // -- 2.1. Interract forward
  onLeaveDown() {
    window.dispatchEvent(this.transitionStart)
    this.buildIntroOuterCont.classList.add('animate__translate-up')
    this.buildIntroBgImg.classList.add('bg-img--zoomed-max')
    this.buildIntroCont.classList.add('building-intro__container--end')
    setTimeout(() => {
      this.buildIntroOuterCont.classList.remove('animate__translate-up')
      this.buildIntroBgImg.classList.remove('bg-img--zoomed')
      this.buildIntroBgImg.classList.remove('bg-img--zoomed-max')
      this.buildIntroCont.classList.remove('building-intro__container--end')
      this.buildIntroTitle.classList.add('building-intro__title--start')
      if (this.buildIntroBtn) { this.buildIntroBtn.classList.add('building-intro__view-btn--start') }
    }, this.ANIM_DUR + this.EXTRA_DUR)
  }

  // -- 2.2. Interract back
  onVisitUp() {
    this.hideVideo()
    this.buildIntroOuterCont.classList.add('animate__translate-down')
    this.buildIntroBgImg.classList.add('bg-img--zoomed')
    setTimeout(() => {
      this.buildIntroTitle.classList.remove('building-intro__title--start')
      if (this.buildIntroBtn) { this.buildIntroBtn.classList.remove('building-intro__view-btn--start') }
    }, this.ANIM_DUR * 3/4)
    setTimeout(() => {
      this.buildIntroOuterCont.classList.remove('animate__translate-down')
    }, this.ANIM_DUR + this.EXTRA_DUR)
    setTimeout(() => {
      window.dispatchEvent(this.transitionEnd)
    }, this.TRANS_DUR)
  }
}
